/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import SocialLogin from 'react-social-login';

// eslint-disable-next-line react/prefer-stateless-function
class SocialButton extends React.Component {
  render() {
    return (
      <button onClick={this.props.triggerLogin} {...this.props} className="googleLogin">
        { this.props.children }
      </button>
    );
  }
}

export default SocialLogin(SocialButton);
